import { PropType, defineComponent, watch } from 'vue'

import { CsAccordion } from '@sunrise/components'
import { LocationAutocomplete } from '@sunrise/types'

import { FilterId } from '../../ts/service/realEstateService.enum'
import { SearchFilters } from '../../ts/service/realEstateService.interface'

import { useResultListFilter } from '../../composables/useResultListFilter'
import MsFilterEnhanced from '../MsFilterEnhanced/MsFilterEnhanced.vue'
import MsFilterLocationArea from '../MsFilterLocationArea/MsFilterLocationArea.vue'
import MsFilterMinMax from '../MsFilterMinMax/MsFilterMinMax.vue'
import { FilterCategoryKey } from './MsResultListFilter.enum'

export default defineComponent({
    name: 'MsResultListFilter',
    components: {
        MsFilterEnhanced,
        CsAccordion,
        MsFilterLocationArea,
        MsFilterMinMax,
    },
    props: {
        locationLevels: { type: Array as PropType<LocationAutocomplete.LOCATION_LEVELS[]>, required: true },
        searchFilters: { type: Object as PropType<SearchFilters>, required: true },
    },
    setup(props) {
        const {
            filtersForSelectedEstate,
            filterMinMaxValues,
            hasValuesForFilterId,
            onUpdateMinMaxValue,
            updateSearchFilters,
        } = useResultListFilter(props.searchFilters)

        watch(
            () => props.searchFilters,
            (searchFilters) => {
                updateSearchFilters(searchFilters)
            },
        )

        return {
            filtersForSelectedEstate,
            filterMinMaxValues,
            FilterId,
            FilterCategoryKey,
            hasValuesForFilterId,
            onUpdateMinMaxValue,
        }
    },
})
